import { Directive, ElementRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[borderErrorContainer]',
})
export class BorderErrorContainerDirective {
  constructor(public elRef: ElementRef) {}
}
